module.exports = __webpack_public_path__ + "img/gq.00acb1cd.png";